jQuery(function($) {
	$('li.mega-menu-item').on('open_panel', function() {
		if( ! $(this).hasClass('mega-secondary-menu-section-item') ){
			$(this).parent().addClass('mega-toggle-on');
			$(this).find('ul.mega-sub-menu').css('z-index', 1000);
			$('.mega-menu-outer-wrapper').addClass('mega-toggle-on');
		}
	});
	$('li.mega-menu-item').on('close_panel', function() {
		if( ! $(this).hasClass('mega-secondary-menu-section-item') ){
			$(this).parent().removeClass('mega-toggle-on');
			$('.mega-menu-outer-wrapper').removeClass('mega-toggle-on');
			setTimeout( () => {
				$(this).find('ul.mega-sub-menu').css('z-index', '');
			}, 300);
		}
	});
	let mobileMenuIsOpen = false;
	$("ul#mega-menu-primary").on("mmm:showMobileMenu", function() {
		mobileMenuIsOpen = true;
		$('body').addClass('max-mega-menu-mobile-menu-open');
		$('#mega-menu-wrap-primary').css('height', '100vh');
		$('.mobile-secondary-menu, .mobile-search').animate({"height":"show"}, 200);
		stretchSecondaryHeight();
		showMobileMenu();
	});
	$("ul#mega-menu-primary").on("mmm:hideMobileMenu", function() {
		if( mobileMenuIsOpen ){
			$('body').removeClass('max-mega-menu-mobile-menu-open');
			$('#mega-menu-wrap-primary').css('height', '');
			$('.mobile-secondary-menu, .mobile-search').animate({"height":"hide"}, 200);
			unStretchSecondaryHeight();
			hideMobileMenu();
			mobileMenuIsOpen = false;
		}
	});
});

const megaMenuItemsWithChildren = document.querySelectorAll('#mega-menu-primary > li.mega-menu-item-has-children:not(.mega-secondary-menu-section-item)');
megaMenuItemsWithChildren.forEach( menuItem => {
	const link = menuItem.querySelector('a.mega-menu-link');
	const linkClone = link.cloneNode(true);
	link.innerHTML = link.innerHTML + '<span class="radix-caret-right"></span>'
	linkClone.innerHTML = '<span class="radix-caret-left"></span>' + linkClone.innerHTML;
	linkClone.dataset.megaMenuParentId = menuItem.id;
	let linkListItem = document.createElement("li");
	linkListItem.appendChild(linkClone);
	const subMenu = menuItem.querySelector('.mega-sub-menu');
	subMenu.insertBefore(linkListItem, subMenu.firstChild);
	linkClone.addEventListener( 'click', e => {
		e.preventDefault();
		const panelToHide = jQuery( "#" + e.currentTarget.dataset.megaMenuParentId + " > a.mega-menu-link");
		jQuery('#mega-menu-primary').data('maxmegamenu').hidePanel(panelToHide, true);
	});
})

const megaMenuItemsWithChildrenSecondary = document.querySelectorAll('#mega-menu-primary > li.mega-menu-item-has-children.mega-secondary-menu-section-item');
megaMenuItemsWithChildrenSecondary.forEach( menuItem => {
	const link = menuItem.querySelector('a.mega-menu-link');
	const linkClone = link.cloneNode(true);
	link.innerHTML = link.innerHTML + '<span class="radix-plus"></span>'
	link.addEventListener( 'click', e => {
		e.preventDefault();
		jQuery('#mega-menu-primary').data('maxmegamenu').hidePanel(jQuery(e.currentTarget), true);
	});
})

//Fill the viewport with gray
// wait to measure until after transition
const sleep = (milliseconds) => {
	return new Promise( resolve => setTimeout(resolve, milliseconds))
}

async function stretchSecondaryHeight() {
	await sleep(200);
	const megaMenuSecondarySectionLastItem = document.querySelector('.mega-secondary-menu-section-last-item')
	let iterator = megaMenuSecondarySectionLastItem;
	let megaMenuWrap = document.getElementById('mega-menu-wrap-primary');
	if( megaMenuSecondarySectionLastItem ){
		let height = megaMenuSecondarySectionLastItem.offsetHeight;
		let topOffset = megaMenuSecondarySectionLastItem.getBoundingClientRect().top;

		while (iterator != document.documentElement) {
			iterator = iterator.parentElement;
			topOffset += iterator.scrollTop;
		  }
		if( window.innerHeight > topOffset ){
			megaMenuSecondarySectionLastItem.style.height = (window.innerHeight - topOffset ) + 'px';
		}

	}
}
const unStretchSecondaryHeight = () => {
	const megaMenuSecondarySectionLastItem = document.querySelector('.mega-secondary-menu-section-last-item')
	if( megaMenuSecondarySectionLastItem ){
		megaMenuSecondarySectionLastItem.style.height = '';
	}
}
//Control background scroll
const showMobileMenu = () => {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}`;
};
const hideMobileMenu = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  document.documentElement.style.scrollBehavior = 'auto'; //Instant scroll
  //window.scrollTo(0, parseInt(scrollY || '0') * -1, 'auto');
  document.documentElement.style.scrollBehavior = ''; //Revert smooth scroll
}
window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});

//Add active state for solutions (and others)
const megaMenuGridItems = document.querySelectorAll( 'ul.max-mega-menu li.mega-menu-grid');
megaMenuGridItems.forEach( menuItem => {
	const ancestors = menuItem.getElementsByClassName('current-page-ancestor')
	const parents = menuItem.getElementsByClassName('current-menu-item')
	if( ancestors.length || parents.length ){
		menuItem.classList.add('mega-current-menu-item');
	}
})
